import {useContext} from "react";
import {ConfirmDialogProps, DialogContext} from "../context/DialogContext";

export function useDialog() : {showConfirmDialog : (data : ConfirmDialogProps) => Promise<boolean>}{
    const dialogHelpers = useContext(DialogContext);
    return dialogHelpers;
}
